var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.5H8C7.45 19.5 6.97933 19.3043 6.588 18.913C6.196 18.521 6 18.05 6 17.5V3.5C6 2.95 6.196 2.479 6.588 2.087C6.97933 1.69567 7.45 1.5 8 1.5H14.175C14.4417 1.5 14.696 1.55 14.938 1.65C15.1793 1.75 15.3917 1.89167 15.575 2.075L20.425 6.925C20.6083 7.10833 20.75 7.32067 20.85 7.562C20.95 7.804 21 8.05833 21 8.325V17.5C21 18.05 20.8043 18.521 20.413 18.913C20.021 19.3043 19.55 19.5 19 19.5ZM14 3.5H8V17.5H19V8.5H15C14.7167 8.5 14.4793 8.40433 14.288 8.213C14.096 8.021 14 7.78333 14 7.5V3.5ZM4 23.5C3.45 23.5 2.97933 23.3043 2.588 22.913C2.196 22.521 2 22.05 2 21.5V8.5C2 8.21667 2.096 7.979 2.288 7.787C2.47933 7.59567 2.71667 7.5 3 7.5C3.28333 7.5 3.521 7.59567 3.713 7.787C3.90433 7.979 4 8.21667 4 8.5V21.5H14C14.2833 21.5 14.521 21.596 14.713 21.788C14.9043 21.9793 15 22.2167 15 22.5C15 22.7833 14.9043 23.0207 14.713 23.212C14.521 23.404 14.2833 23.5 14 23.5H4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/Content.ed0fc9458da873a572b2403542547bca.svg";
export { ForwardRef as ReactComponent };